import axios from '../config/httpRequset'
//灌区查询
export function irrigatedget(data) {
    return axios.get('/irrigation_areas', data)
}
//灌区查询
export function irrigatedgettwo(data) {
    return axios.put('/irrigation_areas/' + data)
}
//灌区添加
export function irrigatedadd(data) {
    return axios.post('/irrigation_areas', data)
}
//灌区修改  
export function irrigatedupdate(data,form) {
    return axios.put('/irrigation_areas/' + data, form)
}
    //灌区删除
export function irrigateddelete(data) {
    return axios.delete('/irrigation_areas/' + data)
}


// 灌区经济社会情况详情
export function irrigationAreas(data) {
    return axios.get('/irrigation_areas/'+data.id+'/irrigation_economys', data)
}
// 灌区经济社会情新增
export function irrigationAreasadd(data) {
    return axios.post('/irrigation_areas/'+data.id+'/irrigation_economys', data)
}
// 灌区经济社会情修改
export function irrigationAreasupdate(data, form) {
    return axios.put('/irrigation_areas/'+data.id+'/irrigation_economys/'+form.id, form)
}

// 灌区经济社会情删除
export function irrigationAreasdelete(data, form) {
    return axios.delete('/irrigation_areas/'+form+'/irrigation_economys/'+data)
}
// 灌区经济社会情详情
export function irrigationAreasget(data,irrid) {
    return axios.get('/irrigation_areas/'+irrid+'/irrigation_economys/'+data)
}

// 灌区年实灌情况列表查询
export function irrigationAreasyear(data) {
    return axios.get('/irrigation_areas/'+data.id+'/irrigation_situations', data)
}
// 灌区年实灌情况新增
export function irrigationAreasyearadd(data) {
    return axios.post('/irrigation_areas/'+data.id+'/irrigation_situations', data)
}
// 灌区年实灌情况修改
export function irrigationAreasyearupdate(data, form) {
    return axios.put('/irrigation_areas/'+data.id+'/irrigation_situations/'+form.id, form)
}
// 灌区年实灌情况删除
export function irrigationAreasyeardelete(data, form) {
    return axios.delete('/irrigation_areas/'+form+'/irrigation_situations/'+data)
}
// 灌区年实灌情况详情
export function irrigationAreasyearget(data, irrid) {
    return axios.get('/irrigation_areas/'+irrid+'/irrigation_situations/'+data)
}
//灌区年投资情况列表查询
export function irrigationAreasyearinvestment(data) {
    return axios.get('/irrigation_areas/'+data.id+'/irrigation_investments', data)
}
//灌区年投资情况新增
export function irrigationAreasyearinvestmentadd(data) {
    return axios.post('/irrigation_areas/'+data.id+'/irrigation_investments', data)
}
//灌区年投资情况修改
export function irrigationAreasyearinvestmentupdate(data, form) {
    return axios.put('/irrigation_areas/'+data.id+'/irrigation_investments/'+form.id, form)
}
//灌区年投资情况删除
export function irrigationAreasyearinvestmentdelete(data, form) {
    return axios.delete('/irrigation_areas/'+form+'/irrigation_investments/'+data)
}
//灌区年投资情况详情
export function irrigationAreasyearinvestmentget(data, irrid) {
    return axios.get('/irrigation_areas/' + irrid + '/irrigation_investments/' + data)
}

// 灌区收入情况列表查询
export function irrigationAreasyearincome(data) {
    return axios.get('/irrigation_areas/'+data.id+'/irrigation_revenues', data)
}
// 灌区收入情况新增
export function irrigationAreasyearincomeadd(form,data) {
    return axios.post('/irrigation_areas/'+form+'/irrigation_revenues', data)
}
// 灌区收入情况修改
export function irrigationAreasyearincomeupdate(data, form) {
    return axios.put('/irrigation_areas/'+data+'/irrigation_revenues/'+form.id, form)
}
// 灌区收入情况删除
export function irrigationAreasyearincomedelete(data, form) {
    return axios.delete('/irrigation_areas/'+form+'/irrigation_revenues/'+data)
}
// 灌区收入情况详情
export function irrigationAreasyearincomeget(data, irrid) {
    return axios.get('/irrigation_areas/'+irrid+'/irrigation_revenues/'+data)
}

//灌区年引供水量
export function irrigationAreasyearsupply(data) {
    return axios.get('/\/\irrigation_areas/'+data.id+'/irrigation_cited_waters', data)
}
//灌区年引供水量新增    
export function irrigationAreasyearsupplyadd(data) {
    return axios.post('/irrigation_areas/'+data.id+'/irrigation_cited_waters', data)
}
//灌区年引供水量修改
export function irrigationAreasyearsupplyupdate(data, form) {
    return axios.put('/irrigation_areas/'+data.id+'/irrigation_cited_waters/'+form.id, form)
}
//灌区年引供水量删除
export function irrigationAreasyearsupplydelete(data, form) {
    return axios.delete('/irrigation_areas/'+form+'/irrigation_cited_waters/'+data)
}
//灌区年引供水量详情
export function irrigationAreasyearsupplyget(data, irrid) {
    return axios.get('/irrigation_areas/'+irrid+'/irrigation_cited_waters/'+data)
}
//渠道信息列表查询
export function channel(data) {
    return axios.get('/irrigation_channels', data)
}
//渠道信息新增
export function channeladd(data) {
    return axios.post('/irrigation_channels', data)
}
//渠道信息修改
export function channelupdate(data, form) {
    return axios.put('/irrigation_channels/'+data, form)
}
//渠道信息删除
export function channeldelete(data, form) {
    return axios.delete('/irrigation_channels/'+form+'/'+data)
}
//渠道信息详情
export function channelget(data) {
    return axios.get('/irrigation_channels/'+data)
}
//灌区灌片查询
export function channelirrigation(data) {
    return axios.get('/irrigation_areas/'+data.id+'/pieces', data)
}
//灌区灌片新增
export function channelirrigationadd(data) {
    return axios.post('/irrigation_areas/'+data.id+'/pieces', data)
}
//灌区灌片修改
export function channelirrigationupdate(data, form) {
    return axios.put('/irrigation_areas/'+data.id+'/pieces/'+form.id, form)
}
//灌区灌片删除
export function channelirrigationdelete(data, form) {
    return axios.delete('/irrigation_areas/'+form+'/pieces/'+data)
}
//灌区灌片详情
export function channelirrigationget(data, irrid) {
    return axios.get('/irrigation_areas/'+irrid+'/pieces/'+data)
}

//渠道技术信息列表查询
export function channeltechnology(data) {
    return axios.get('/irrigation_channels/'+data.id+'/channel_arts', data)
}
//渠道技术信息新增
export function channeltechnologyadd(data) {
    return axios.post('/irrigation_channels/'+data.id+'/channel_arts', data)
}
//渠道技术信息修改
export function channeltechnologyupdate(data, form) {
    return axios.put('/irrigation_channels/'+data.id+'/channel_arts/'+form.id, data)
}
//渠道技术信息删除
export function channeltechnologydelete(data, form) {
    return axios.delete('/irrigation_channels/'+form+'/channel_arts/'+data)
}
//渠道技术信息详情
export function channeltechnologyget(data, irrid) {
    return axios.get('/irrigation_channels/'+irrid+'/channel_arts/'+data)
}

//陡坡列表查询
export function stepslope(data) {
    return axios.get('/irrigation_channels/'+data.id+'/steep_slopes', data)
}
//陡坡新增
export function stepslopeadd(data) {
    return axios.post('/irrigation_channels/'+data.id+'/steep_slopes', data)
}
//陡坡修改
export function stepslopeupdate(data, form) {
    return axios.put('/irrigation_channels/'+data.id+'/steep_slopes/'+form.id, form)
}
//陡坡删除
export function stepslopedel(data, form) {
    return axios.delete('/irrigation_channels/'+form+'/steep_slopes/'+data)
}
//陡坡详情
export function stepslopeget(data, irrid) {
    return axios.get('/irrigation_channels/'+irrid+'/steep_slopes/'+data)
}

//灌区调水计划列表查询
export function irrigationplan(data) {
    return axios.get('/irrigation_areas/'+data.id+'/water_diversion_schemes', data)
}
//灌区调水计划新增
export function irrigationplanadd(data) {
    return axios.post('/irrigation_areas/'+data.id+'/water_diversion_schemes', data)
}
//灌区调水计划修改
export function irrigationplanupdate(data, form) {
    return axios.put('/irrigation_areas/'+data.id+'/water_diversion_schemes/'+form.id, data)
}
//灌区调水计划删除
export function irrigationplandel(data, form) {
    return axios.delete('/irrigation_areas/'+form+'/water_diversion_schemes/'+data)
}
//灌区调水计划详情
export function irrigationplanget(data, irrid) {
    return axios.get('/irrigation_areas/'+irrid+'/water_diversion_schemes/'+data)
}


